import SectionHead from "../components/SectionHead";
import ServicesGrid from "../components/home/ServicesGrid";
import ContactForm from "../components/ContactForm";
import { Reveal } from "../components/motion";
import { useLang } from "../i18n";

const ServicesPage = () => {
    const { t } = useLang();
    return (
        <main className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
            <SectionHead
                eyebrow={t.servicesPage.eyebrow}
                title={t.servicesPage.title}
                sub={t.servicesPage.sub}
                testid="services-page-title"
            />
            <ServicesGrid />

            <section className="mt-24 grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <SectionHead
                        eyebrow={t.servicesPage.ctaEyebrow}
                        title={t.servicesPage.ctaTitle}
                        sub={t.servicesPage.ctaSub}
                    />
                </div>
                <Reveal className="lg:col-span-7">
                    <div className="rounded-[2rem] border border-[#E3DCCF] bg-white p-6 shadow-sm sm:p-9">
                        <ContactForm />
                    </div>
                </Reveal>
            </section>
        </main>
    );
};

export default ServicesPage;
